import type { IconData } from '@stacksjs/iconify-core'

export const hu4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#fff\" d=\"M640 480H0V0h640z\"/><path fill=\"#388d00\" d=\"M640 480H0V320h640z\"/><path fill=\"#d43516\" d=\"M640 160.1H0V.1h640z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default hu4x3
